var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "10.7818mm",
    height: "11.3554mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 196.26 206.7",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    y: 148.52,
    width: 196.26,
    height: 4.04
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    y: 202.65,
    width: 196.26,
    height: 4.04
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993338410944"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M153.49 121.41l-110.77 0 0 -110.77 110.77 0 0 110.77zm-106.68 -4.05l102.49 0 0 -102.63 -102.49 0 0 102.63z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993338412768"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M70.99 52.53c-7.55,0 -13.68,-6.13 -13.68,-13.68 0,-7.55 6.13,-13.68 13.68,-13.68 7.55,0 13.68,6.13 13.68,13.68 0,0.01 0,0.03 0,0.05 0,0 0,0 0,0 0,7.53 -6.1,13.63 -13.63,13.63 -0.01,0 -0.03,0 -0.05,0l0 -0zm0 -23.26c-5.32,0 -9.63,4.31 -9.63,9.63 0,5.32 4.31,9.63 9.63,9.63 5.32,0 9.63,-4.31 9.63,-9.63 0,-5.32 -4.31,-9.63 -9.63,-9.63l-0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993338414688"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    d: "M123.97 52.53c-7.55,0 -13.68,-6.13 -13.68,-13.68 0,-7.55 6.13,-13.68 13.68,-13.68 7.55,0 13.68,6.13 13.68,13.68 0,0.01 0,0.03 0,0.05 0,0 0,0 0,0 0,7.53 -6.1,13.63 -13.63,13.63 -0.01,0 -0.03,0 -0.05,0l0 -0zm0 -23.26c-5.32,0 -9.63,4.31 -9.63,9.63 0,5.32 4.31,9.63 9.63,9.63 5.32,0 9.63,-4.31 9.63,-9.63 0,-5.32 -4.31,-9.63 -9.63,-9.63z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993338414160"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M70.99 106.81c-7.51,-0.03 -13.58,-6.12 -13.58,-13.63 0,-7.53 6.1,-13.63 13.63,-13.63 7.53,0 13.63,6.1 13.63,13.63 0,0 0,0 0,0 0,7.53 -6.1,13.63 -13.63,13.63 -0.01,0 -0.03,0 -0.05,0l0 0zm0 -23.21c-5.32,0 -9.63,4.31 -9.63,9.63 0,5.32 4.31,9.63 9.63,9.63 5.32,0 9.63,-4.31 9.63,-9.63 0,-5.32 -4.31,-9.63 -9.63,-9.63l-0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1993338416464"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    fillRule: "nonzero",
    d: "M123.97 106.81c-7.51,-0.03 -13.58,-6.12 -13.58,-13.63 0,-7.53 6.1,-13.63 13.63,-13.63 7.53,0 13.63,6.1 13.63,13.63 0,0 0,0 0,0 0,7.53 -6.1,13.63 -13.63,13.63 -0.01,0 -0.03,0 -0.05,0l0 0zm0 -23.21c-5.32,0 -9.63,4.31 -9.63,9.63 0,5.32 4.31,9.63 9.63,9.63 5.32,0 9.63,-4.31 9.63,-9.63 0,-5.32 -4.31,-9.63 -9.63,-9.63z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M29.48 190.47c-7.47,-0.11 -13.48,-6.2 -13.48,-13.68 0,-7.55 6.13,-13.68 13.68,-13.68 7.55,0 13.68,6.12 13.68,13.68 0,0 0,0 0,0 0,7.55 -6.13,13.68 -13.68,13.68 -0.06,0 -0.13,-0 -0.19,-0l-0 0zm0 -23.26c-5.32,-0.01 -9.63,4.31 -9.63,9.63 0,5.32 4.31,9.63 9.63,9.63 5.32,0 9.63,-4.31 9.63,-9.63 0,-5.32 -4.31,-9.63 -9.63,-9.63l-0 0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M168.03 190.47c-0.01,-0 -0.03,-0 -0.05,-0 -7.55,0 -13.68,-6.13 -13.68,-13.68 0,-7.55 6.13,-13.68 13.68,-13.68 7.55,0 13.68,6.13 13.68,13.68 0,0 0,0 0,0 0,7.53 -6.09,13.65 -13.63,13.68l-0 0zm0 -23.26c-5.32,-0.01 -9.63,4.31 -9.63,9.63 0,5.32 4.31,9.63 9.63,9.63 5.32,0 9.63,-4.31 9.63,-9.63 0,-5.32 -4.31,-9.63 -9.63,-9.63l0 0.01z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    y: 175.59,
    width: 17.82,
    height: 4.04
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 41.56,
    y: 175.59,
    width: 114.86,
    height: 4.04
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 178.39,
    y: 175.59,
    width: 17.82,
    height: 4.04
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 33.6144 2.86057)",
    width: 4.04,
    height: 178.34
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 33.6479 126.106)",
    width: 178.34,
    height: 4.04
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc29);
export default __webpack_public_path__ + "static/media/ic_2_9.785157a377685a2d9d7cc7ad79fcfaf9.svg";
export { ForwardRef as ReactComponent };